/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function averageMobileReviews(reviewsByCarrier) {
    let averageRating = 0;

    if (Array.isArray(reviewsByCarrier)) {
        // Calculate average of all carrier reviews
        const reducedValue = reviewsByCarrier.reduce(
            ({ ratingSum, totalRatings }, item) => {
                return {
                    ratingSum: ratingSum + item.average_rating * item.number_of_ratings,
                    totalRatings: totalRatings + item.number_of_ratings,
                };
            },
            { ratingSum: 0, totalRatings: 0 }
        );

        averageRating = reducedValue.ratingSum / (reducedValue.totalRatings || 1);
    }

    return averageRating;
}
